import { jsx as _jsx } from "react/jsx-runtime";
import { Toaster, toast } from 'sonner';
/**
 * Triggers a Sonner toast based on the legacy ToastProps interface.
 * Called internally by SourContext's setShowToast.
 */
export function triggerSonnerToast(props) {
    const { message, severity, duration = 2500, handleOnClose, onlyCloseOnClick } = props;
    if (!message)
        return;
    const options = {
        duration: onlyCloseOnClick ? Infinity : duration,
        onDismiss: handleOnClose,
        onAutoClose: handleOnClose,
    };
    switch (severity) {
        case 'success':
            toast.success(message, options);
            break;
        case 'error':
            toast.error(message, options);
            break;
        case 'warning':
            toast.warning(message, options);
            break;
        case 'info':
            toast.info(message, options);
            break;
        default:
            toast(message, options);
            break;
    }
}
/**
 * Renders the Sonner Toaster provider. Place once at the app root.
 */
export const Toast = ({ position = 'top-right' }) => {
    return _jsx(Toaster, { position: position, richColors: true, closeButton: true });
};
//# sourceMappingURL=toast.js.map